import styled from 'styled-components';

export const HeaderBanner = styled.div`
  padding: 1rem 0;
`;

export const HeaderSubtitle = styled.p`
  padding-bottom: 1.5rem;
`;
